export default __webpack_public_path__ + "static/media/330_business02-fr-web.c5103762.png";